import React from "react";
import styles from "./TaglineMarquee.module.css";

const TaglineMarquee: React.FC = () => {
  const text = "ॐ श्री गणेशाय नमः";

  // phrase = "॥ text ॥ [swastik]"
  const Phrase = ({ i, ariaHidden = false }: { i: number; ariaHidden?: boolean }) => (
    <span className={styles.phrase} key={i} aria-hidden={ariaHidden}>
      <span className={styles.danda}>॥</span>
      <span className={styles.item}>{text}</span>
      <span className={styles.danda}>॥</span>
      <img
        src="/Assets/swastik.png"
        alt=""
        role="presentation"
        className={styles.inlineIcon}
        draggable={false}
        loading="eager"
      />
    </span>
  );

  // build groups
  const phrases = Array.from({ length: 8 }, (_, i) => <Phrase i={i} key={i} />);
  const phrasesClone = Array.from({ length: 8 }, (_, i) => (
    <Phrase i={i} key={`c-${i}`} ariaHidden />
  ));

  return (
    <div className={styles.bar} lang="hi" aria-label={text}>
      {/* fixed Ganesh ji on edges */}
      <img
        src="/Assets/god.png"
        alt="Shri Ganesh"
        className={`${styles.edgeIcon} ${styles.left}`}
        draggable={false}
        loading="eager"
      />
      <img
        src="/Assets/god.png"
        alt="Shri Ganesh"
        className={`${styles.edgeIcon} ${styles.right}`}
        draggable={false}
        loading="eager"
      />

      {/* scrolling track */}
      <div className={styles.marquee}>
        <div className={styles.group}>
          {/* initial swastik to begin the chain */}
          <img src="/Assets/swastik.png" alt="" role="presentation" className={styles.inlineIcon} />
          {phrases}
        </div>
        <div className={styles.group} aria-hidden="true">
          <img src="/Assets/swastik.png" alt="" role="presentation" className={styles.inlineIcon} />
          {phrasesClone}
        </div>
      </div>
    </div>
  );
};

export default TaglineMarquee;
